import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-regulation',
  templateUrl: './regulation.page.html',
  styleUrls: ['./regulation.page.scss']
})
export class RegulationPage {
  
  constructor(private router: Router) {}

  goBack() {
    this.router.navigate(['/login']);
  }

  defineOut(text: string): string {
    // Método para substituir placeholders dinâmicos se necessário
    const replacements: { [key: string]: string } = {
      'perfil': '<strong>perfil</strong>',
      'area_de_pedidos': '<strong>área de pedidos</strong>'
    };
    return replacements[text] || text;
  }
}
